import { Component, input } from '@angular/core';
import { NamedIdentityWithCreatorDTO } from '../../../services/api/api';

@Component({
  selector: 'sb-comp-display-created',
  standalone: false,
  templateUrl: './display-created.component.html',
  styleUrl: './display-created.component.scss',
})
export class DisplayCreatedComponent {
  data = input.required<NamedIdentityWithCreatorDTO>();
  hideIcon = input(false);
  reverse = input(false);
  showHeadline = input(false);
  dateFormat = input('dd.MM.yy HH:mm:ss');
}
